<template>
  <div>
  <Breadcrumbs main="Payments" title="Airtime Purchase" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-3 pr-sm-0 box-col-12">
          <div class="file-sidebar">
            <div class="card">
              <div class="card-body">
                <ul>
                <li>
                <router-link to="/bills/airtime-purchase">
                    <div class="btn btn-primary">
                      <feather type="phone"></feather>
                      Airtime Purchase
                    </div>
                    </router-link>
                  </li>
                  <li>
                  <router-link to="/bills/data-purchase">
                    <div class="btn btn-light">
                      <feather type="smartphone"></feather>
                        Data Purchase
                    </div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-md-12 box-col-12">
          <div class="file-content">
            <div class="card">
              <div v-if="loading" class="loader-12"></div>
              <div class="card-header">
                <h5>Airtime Purchase</h5>
                <span>Initiate a new airtime purchase request.</span>
              </div>
              <div id="RequestFormSection" class="animated fadeIn">
                  <div class="card-body">
                      <form class="theme-form is-validated" autocomplete="off" id="Submit_Transfer_Form">
                          <!-- Initiate the Transfer -->
                          <div id="InitiateTransfer" v-show="step === 1">
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="AccountNumber">Source Account <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <select v-model="form.accountNumber" placeholder="Select From Account *" class="form-select acct-num" data-val-length="The field AccountNumber must be a string with a maximum length of 250." data-val-length-max="250" data-val-required="The AccountNumber field is required." id="AccountNumber" name="AccountNumber" required="required"><option :value="null" disabled>Select From Account *</option>
                                        <option v-for="account in userAccounts" :value="account.accountNumber" :key="account.id">{{account.accountNumber}} (Acct No: {{account.accountName}} | Balance: {{account.availableBalance}})</option>
                                      </select>
                                      <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="AccountNumber" data-valmsg-replace="true"></span>
                                  </div>
                              </div>
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="DestinationAccountNumber">Network <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <select v-model="form.biller" class="form-select acct-num" required="required"><option :value="form.biller" disabled>{{ form.biller ? form.biller : 'Select Network *'}}</option>
                                      <option v-for="biller in airtimeBillers" :value="biller.billerName" :key="biller.billerName">{{biller.billerName}}</option>
                                      </select>
                                      <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="AccountNumber" data-valmsg-replace="true"></span>
                                  </div>
                              </div>
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label">Amount <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <input class="form-control" @paste.prevent @change="formatInput" min="0" @keypress="isNumber" @keyup="formatNum" v-model="form.amount" data-val-number="The field Amount must be a number." data-val-required="The Amount field is required." id="Amount" name="Amount" placeholder="Enter Amount *" required="required" type="text" value="" />
                                      <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="Amount" data-valmsg-replace="true"></span>
                                  </div>
                              </div>
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label">Phone Number <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <input class="form-control" @paste.prevent maxlength="11" @click="removeReadonly" id="no-paste" autocomplete="off" pattern="\d*" @keypress="isNumber" min="0" v-model="form.phoneNumber" placeholder="Enter Phone Number *" type="text" value="" />
                                      <p class="pull-right mt-2 ms-2">
                                        <button type="button" class="beneModal" data-toggle="modal" data-target="#exampleModal">
                                          <a data-toggle="modal" data-target="#exampleModal" class="primary-color"><i class="fa fa-users"></i> Select from Beneficiaries</a>
                                      </button>
                                    </p>
                                  </div>
                              </div>
                              <!-- <div class="mb-3 row" v-if="isBudgetConfigured">
                                  <label class="col-sm-3 col-form-label">Select Category</label>
                                  <div class="col-sm-9 col-xl-7">
                                      <select v-model="form.categoryName" class="form-select acct-num">
                                      <option :value="null" disabled>Select Category</option>
                                      <option v-for="category in myCategories" :value="category.name" :key="category.id">{{category.name}}</option>
                                      </select>
                                  </div>
                              </div> -->
                              <div class="row mt-4">
                                  <div class="col-sm-12 offset-lg-3 offset-sm-0">
                                      <button type="button" @click="inititatePurchase" class="btn btn-round btn-primary mr-1">
                                      <div v-if="loading">
                                        <i class='fa fa-refresh fa-spin'></i>&nbsp;Verifying Transaction...
                                      </div>
                                      <div v-else>
                                        Proceed<i class="fa fa-angle-right ml-2"></i>
                                      </div>
                                      </button>
                                      <button type="button" @click="resetForm" class="btn btn-outline-danger">Cancel</button>
                                  </div>
                              </div>
                          </div>
                          <!-- Verify Account Name and Submit Transfer Request -->
                          <div id="AccountNameVerification" v-show="step === 2">
                              <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label"></label>
                                <div class="col-sm-9 col-xl-7">
                                    <h6>Confirm Airtime Purchase:</h6>
                                    <p>
                                        Network: <b><span id="network-display" class="text-danger">{{form.biller}}</span></b><br />
                                        Amount: <b><span id="amount-display" class="text-danger">{{form.amount}}</span></b><br />
                                        Phone Number: <b><span id="phone-display" class="text-danger">{{form.phoneNumber}}</span></b>
                                    </p>
                                    <p>Note that a transaction fee of <span style="color:#E41613;">N{{vatFee}}</span> would apply.</p>
                                </div>
                            </div>
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="Token">Transaction Pin <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <input class="form-control" @paste.prevent @keypress="isNumber" min="0" v-model="form.transactionPin" pattern="\d*" maxlength="4"  placeholder="Enter Your Transaction Pin *" required="required" :type="type" value="" />
                                      <div class="show-hide" @click="showPin"><span :class="type === 'password' ? 'show' : 'hide'"></span></div>
                                      <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="Token" data-valmsg-replace="true"></span>
                                  </div>
                              </div>
                              <br />
                              <div class="mb-3 row">
                                  <div class="col-sm-9  offset-lg-3 offset-sm-0">
                                      <button type="button" class="btn btn-primary mr-2" @click="SubmitTransaction">
                                        <div v-if="loading">
                                          <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                                        </div>
                                        <div v-else>
                                          Submit <i class="fa fa-check ms-2"></i>
                                        </div>
                                      </button>
                                      <button type="button" class="btn btn-outline-danger" @click="goBackTo">Go Back</button>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>

              <!-- Request Success Response -->
              <div v-show="step === 3" id="RequestSuccessResponseSection" class="animated fadeIn mb-5">
                  <div class="card-content pt-2 pl-3 pb-2 pr-3">
                      <div class="p-2 text-center">
                          <img src="@/assets/TAJimages/notification/success.png" alt="Error Icon image" class="img-fluid" />
                          <h5 class="text-bold-700 mb-2 text-success"><i class="feather icon-check-circle fa-2x"></i> TRANSACTION SUCCESSFUL!</h5>
                          <p id="SuccessMessage">Your transaction has been completed successfully!</p>
                          <h6 class="text-default text-bold-700">Reference: <span id="SuccessReferenceId">{{ form.transactionReference }}</span></h6>
                          <p class="mt-4">
                              <a @click="reload" class="btn btn-danger btn-round">New Airtime Purchase <i class="fa fa-refresh"></i></a>
                              <router-link to="/dashboard/transaction-history"><a class="btn btn-outline-danger btn-round ml-2">View Transactions <i class="fa fa-angle-right"></i></a></router-link>
                          </p>
                      </div>
                  </div>
              </div>

              <!-- Request Failure Response -->
              <div v-show="step === 'error'" class="animated fadeIn mt-4 mb-5" style="display:none">
                  <div class="card-content p-3 text-center">
                      <img src="@/assets/TAJimages/notification/oops.png" alt="Error Icon image" class="img-fluid mb-2" />
                      <h5 class="text-bold-700 mb-2 text-danger"><i class="feather icon-alert-triangle"></i> Oops! Something went wrong.</h5>
                      <p>There was an error processing your request.</p>
                      <p id="ResponseError" class="text-danger"></p>
                      <p>
                          <a class="btn btn-danger btn-round" @click="goBackTo">Retry <i class="fa fa-refresh ms-1"></i></a>
                      </p>
                  </div>
              </div>
          </div>
      </div>
      <!-- beneficiary list Modal -->
      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title pl-2" id="exampleModalLabel">Select Beneficiary</h5>
              <button type="button" class="close text-dark" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <table class="table table-striped">
                <thead>
                  <tr>
                      <th>Beneficiary Details</th>
                  </tr>
                </thead>
                <tbody>
                <div v-if="getbeneficiaryList.length >= 1 ">
                  <div v-for="beneficiary in getbeneficiaryList" :key="beneficiary.id">
                    <div class="pt-2 px-3">{{beneficiary.phoneNumber ? beneficiary.phoneNumber : 'N/A'}} - {{beneficiary.biller ? beneficiary.biller : 'N/A'}}<br>
                    <p style="cursor:pointer" @click="selectBeneficiary(beneficiary.id)" class="text-white mt-2 badge badge-danger"><i class='fa fa-check mb-1'></i> Select</p>
                    <hr v-if="getbeneficiaryList.length > 1"/>
                    </div>
                  </div>
                  </div>
                  <tr v-else class="text-center my-3">No Beneficiary</tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import { mapState } from 'vuex';
  import $ from 'jquery';
  import { decrypt } from '@/_services/encryption';
  import moment from 'moment';
  export default {
    data:() => ({
      form: {
        accountNumber: null,
        phoneNumber: null,
        // categoryName: null,
        biller: null,
        transactionReference: null,
        amount: '0.00',
        transactionPin: null,
        platform: 1,
      },
      transactionReference: null,
      step: 1,
      loading: false,
      type: 'password',
      vatFee: 0,
      isBudgetConfigured: false,
    }),
    computed: {
      ...mapState({
        // eslint-disable-next-line no-confusing-arrow
        userAccounts: state => state.dashboard.dashboardData ? state.dashboard.dashboardData.accounts : [],
        airtimeBillers: state => state.bills.airtimeBillers,
        beneficiaryList: state => state.beneficiaries.beneficiaries,
        myCategories: state => state.budget.myCategories,
      }),
      ...mapState('transfers', ['duplicateTransactionPeriod']),
      getbeneficiaryList() {
        return this.beneficiaryList.filter(beneficiary => beneficiary.transactionType === 5);
      },
      formatAmount() {
        var formAmount =
          new Intl.NumberFormat('en-NG',{ 
            style: 'currency', 
            currency: 'NGN', 
            minimumFractionDigits: 2 
          });
        return formAmount.format(this.form.amount);
      },
    },
    async mounted() {
      this.$store.dispatch('bills/getAirtimeBillers');
      this.$store.dispatch('beneficiaries/getBeneficiaries');
      this.$store.dispatch('dashboard/getDashboardData').then((response) => {
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        if(response.status === 200) {
          userParseData.accounts.forEach((account) => {
            this.isBudgetConfigured = account.isBudgetConfigured;
          });
          this.$store.dispatch('budget/myCategories', this.userAccounts[0].accountNumber);
        }
      });
    },
    methods : {
      formatInput(event) {
        this.form.amount = event.target.value;
        const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
        this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
      },
      formatNum(event) {
        if(this.form.amount === '') {
          this.form.amount = '0.00';
        } else {
          this.form.amount = event.target.value;
          const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
          this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
        }
        if(event.key === 'Backspace' || event.key === 'Delete') {
          if(event.target.value.length <= 4) {
            const formatter = new Intl.NumberFormat('en-US');
            this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
            if(event.target.value.length < 2) {
              this.form.amount = '0.00';
            }
          } else {
            const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
            this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
            return;
          }
        }		
        // if(event.target.value.length === 2)    event.target.value = '0.00';
      },
      isNumber(event) {
        // prevent user to enter non-numeric value
        if (event.keyCode < 48 || event.keyCode > 57) {
          event.returnValue = false;
        }
      },
      selectBeneficiary(val) {
        this.getbeneficiaryList.forEach(beneficiary => {
          if (beneficiary.id === val) {
            this.form.phoneNumber = beneficiary.phoneNumber;
            this.form.biller = beneficiary.biller;
            $('#exampleModal').modal('hide');
          }
        });
      },
      // show pin
      showPin() {
        this.type = this.type === 'password' ? 'text' : 'password';
      },
      goNext() {
        this.step++;
      },
      goBackTo() {
        this.step = 1;
        this.form.transactionPin = null;
      },
      async inititatePurchase() {
        if (this.form.amount < 50) {
          this.$swal({
            title:'Oops...',
            text: 'Minimum amount is NGN50',
            type:'error'
          });
          return;
        }
        // check for all fields
        if (this.form.accountNumber === null || this.form.biller === null || this.form.amount === null || this.form.phoneNumber === null) {
          this.$swal({
            title:'Oops...',
            text:'Please fill all required fields',
            type:'error'
          });
          return;
        } 
        // check if phone number is less than or greater than 11 digits
        if (this.form.phoneNumber.length < 11 || this.form.phoneNumber.length > 11) {
          this.$swal({
            title:'Oops...',
            text:'Phone number must be 11 digits',
            type:'error'
          });
          return;
        } else {
          this.$swal({
            text:`You are about to recharge NGN${this.form.amount} to ${this.form.phoneNumber}`,
            showCancelButton: true,
            confirmButtonText: 'Proceed',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn btn-primary',
            confirmButtonClass: 'btn btn-success mr-2',
            buttonsStyling: false,
            type:'warning'
          }).then((result)=>{
            this.loading = true;
            if(result.value){
              const data = {
                accountNumber: this.form.accountNumber,
                transactionType: 5,
                amount: Number(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
                platform: this.form.platform,
              };
              this.$store.dispatch('transfers/transactionEnquiry', data).then(async (response) => {
                const decryptedData = decrypt(response.data);
                const userParseData = JSON.parse(decryptedData);
                this.form.transactionReference = userParseData.transactionReference;
                this.vatFee = userParseData.fee.total;
                if (response.status === 200) {
                  this.step = 2;
                  this.loading = false;
                }
              }).catch((error) => {
                const decryptedError = decrypt(error.response.data);
                const objError = JSON.parse(decryptedError);
                this.$swal({
                  title:'Oops...',
                  text: objError.errors[0],
                  type:'error'
                });
                this.loading = false;
              });
            } else {
              this.loading = false;
            }
          });
        }
      },
      // save transaction to session storage
      saveTransaction (value, oldData) {
        const array = [];
        const data = {
          accountNumber: value.accountNumber,
          phoneNumber: value.phoneNumber,
          amount: value.amount,
          transactionType: value.transactionType,
          transactionTime: new Date().toLocaleTimeString()
        };
        array.push(data);
        const list = [...array, ...oldData];
        sessionStorage.setItem('transactionList', JSON.stringify(list));
      },
      // check for duplicate transaction
      checkDuplicateTransaction(txndata) {
        let check = false;
        const transaction = JSON.parse(sessionStorage.getItem('transactionList')) || [];
        const currentTime = new Date().toLocaleTimeString();
        const result = transaction.filter(d => {
          var time = moment.utc(currentTime, 'HH:mm:ss A').diff(moment.utc(d.transactionTime, 'HH:mm:ss A'), 'minutes');
          return (txndata.accountNumber === d.accountNumber && txndata.transactionType === d.transactionType && txndata.phoneNumber === d.phoneNumber && txndata.amount === d.amount && time < this.duplicateTransactionPeriod);
        });
        let timeFilter = [...new Set(result)];
        if (timeFilter.length >= 1) {
          this.$swal({
            title:'Oops...',
            text:`Possible duplicate transaction. Kindly wait for ${this.duplicateTransactionPeriod} minutes and try again!`,
            type:'error'
          });
          check = true;
          return check;
        } else {
          check = false;
          return check;
        }
      },
      SubmitTransaction() {
        this.form.amount = this.form.amount.toString();
        this.form.amount = Number(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
        let categoryName;
        this.myCategories.map(category => {
          if (category.name === 'Airtime & Data') {
            return categoryName = category.name;
          }
        });
        const transactionType = 5;
        const data = this.isBudgetConfigured === false || categoryName !== 'Airtime & Data' ? this.form : { ...this.form, categoryName: categoryName, transactionType };
        const isDuplicate = this.checkDuplicateTransaction(data);
        if (!isDuplicate)  {
          this.loading = true;
          this.$store.dispatch('bills/purchaseAirtime', data).then(response => {
            // save transaction to DB
            const transaction = JSON.parse(sessionStorage.getItem('transactionList')) || [];
            const transactionData = transaction.length >= 1 ? transaction : [];
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (userParseData.responseCode !== '00') {
              this.saveTransaction(data, transactionData);
              this.loading = false;
              this.$swal({
                text: userParseData.responseDescription,
                type:'warning'
              });
            } else {
              this.transactionReference = userParseData.sessionId;
              this.loading = false;
              this.step = 3;
            }
          }).catch((error) => {
            this.loading = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title:'Oops...',
              text: objError.errors[0],
              type:'error'
            });
          });
        }
      },
      resetForm() {
        // reset the form
        this.form.accountNumber = null;
        this.form.phoneNumber = null;
        this.form.biller = null;
        this.form.amount = '0.00';
        this.form.transactionPin = null;
        this.form.categoryName = null;
      },
      reload() {
        this.resetForm();
        this.step = 1;
      }
    },
  };
</script>
<style scoped>
.file-content .card .card-header,
.file-content .card .card-body {
  padding: 40px !important;
}
.card .card-header h5 {
    font-size: 23px;
    font-weight: 300;
}
.btn-light {
    background-color: #e6e6e6 !important;
    color: #000000!important;
    /* border-color: rgba(228, 31, 19, 0.06) !important; */
}
.theme-form select.acct-num {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-control {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-select {
  width: 100%;
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  color: #898989;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem
}
.form-control::placeholder {
  color: #898989;
}
.pull-right {
  color:#E41613;
}
.btn-outline-danger {
  border-color: #e6e6e6;
  color: #000;
  margin-left: 5px;
}
.swal2-actions >>> .swal2-confirm {
  background-color: #1a803f !important;
}
.loader-12 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5) url("../../assets/TAJimages/backgrounds/taj_loader_sm.gif") center center no-repeat;
  z-index: 1000;
  border-radius: 10px;
}
.beneModal {
  background-color: transparent;
  border: none;
}
.table {
  margin-top: 0 !important;
}
.table th {
  border: 0 !important;
}
</style>